import { useSearchParams } from '@remix-run/react'

import useUserSignup from './useUserSignupState'
import { useOnEmailChange } from '../SignupUtils'
import Input from '../../../components/forms/Input'
import { SelectCityFormInput } from '../../../components/forms/SelectCity'

import * as styles from '../SignupShared.styles'
import DateOfBirthInput from './DateOfBirthInput'
import { UserSignupFormErrors } from './FanSignupForm'

interface UserSignupFieldsProps {
  userSignupState: ReturnType<typeof useUserSignup>
  errors: UserSignupFormErrors
  setErrors: (errors: UserSignupFormErrors) => void
}

const UserSignupFields: React.FC<UserSignupFieldsProps> = ({
  userSignupState: {
    fields: { name, email, password, passwordConfirmation, birthday, city },
    setters: {
      setName,
      setEmail,
      setPassword,
      setPasswordConfirmation,
      setBirthday,
      setCity,
    },
  },
  errors,
  setErrors,
}) => {
  const onEmailChange = useOnEmailChange(setEmail, errors, setErrors)
  const [searchParams] = useSearchParams()
  const searchParamEmail = searchParams.get('email')

  return (
    <>
      <Input
        css={styles.textField}
        name="name"
        value={name}
        onChange={(e) => setName(e.currentTarget.value)}
        error={errors.name}
        placeholder="Account holder name"
        label="Name"
        type="text"
        focus
        iconClassName="fa fa-user"
      />
      <Input
        css={styles.textField}
        name="email"
        value={email}
        onChange={onEmailChange}
        error={errors.email}
        placeholder="Email"
        label="Email"
        type="email"
        iconClassName="fa fa-envelope"
        disabled={Boolean(searchParamEmail)}
      />
      <Input
        css={styles.textField}
        name="password"
        value={password}
        onChange={(e) => setPassword(e.currentTarget.value)}
        error={errors.password}
        placeholder="Password"
        type="password"
        label="Password"
        iconClassName="fa fa-key"
        labelEndElement={
          <span css={styles.smallText}>
            We recommend{' '}
            <a
              href="https://1password.com"
              target="_blank"
              rel="noreferrer"
              tabIndex={-1}
            >
              1Password
            </a>
          </span>
        }
      />
      <Input
        css={styles.textField}
        name="passwordConfirmation"
        value={passwordConfirmation}
        onChange={(e) => setPasswordConfirmation(e.currentTarget.value)}
        error={errors.passwordConfirmation}
        placeholder="Confirm password"
        type="password"
        label="Confirm password"
        iconClassName="fa fa-key"
      />

      <SelectCityFormInput
        value={city}
        onChange={(city) => {
          if (city) {
            setCity(city)
          } else {
            setCity({ value: 1, label: 'Glasgow' })
          }
        }}
      />

      <DateOfBirthInput initialDate={birthday} onChange={setBirthday} />
      <small css={styles.secondary}>
        We'll never share your personal information with anyone.
      </small>
    </>
  )
}

export default UserSignupFields
